module.exports = __webpack_public_path__ + "img/activity6.9b63a311.jpg";